import { Link } from "react-router-dom";

export const isExternal = (to) => /^https?:\/\//.test(to);

// Internal routes use the router; external URLs always open in a new tab.
export default function SmartLink({ to, children, ...props }) {
    if (isExternal(to)) {
        return (
            <a href={to} target="_blank" rel="noopener noreferrer" {...props}>
                {children}
            </a>
        );
    }
    return (
        <Link to={to} {...props}>
            {children}
        </Link>
    );
}
